/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient, handleTokenAuth } from './api'
import { handleError } from './error';

export const loadCommon = () => (dispatch, getState) => {
  dispatch({ type: actionTypes.LOADING_COMMON });
  return apiClient.get('o/common/all', handleTokenAuth(getState))
    .then(response => dispatch({
      type: actionTypes.LOADED_COMMON,
      data: response.data.data
    }))
    .catch(handleError(dispatch, actionTypes.ERROR_COMMON));
};

export function searchOrganizationByName(escapedString) {
  return apiClient.get(`o/common/organization/search?q=${escapedString}`)
    .then(response => response.data.data)
}

export function searchUserByOrganization(escapedString, organizationId) {
  return apiClient.get(`users/organization/${organizationId}/search?s=${escapedString}`)
    .then(response => response.data.data.map(d => {
      d.name = `${d.firstName} ${d.surname}`;
      return d;
    }));
}

export function searchUserByInitiative(escapedString, initiativeId) {
  return apiClient.get(`users/initiative/${initiativeId}/search?s=${escapedString}`)
    .then(response => response.data.data.map(d => {
      d.name = `${d.firstName} ${d.surname}`;
      return d;
    }));
}

export function searchUserBySurvey(escapedString, surveyId) {
  return apiClient.get(`users/survey/${surveyId}/search?s=${escapedString}`)
    .then(response => response.data.data.map(d => {
      d.name = `${d.firstName} ${d.surname}`;
      return d;
    }));
}

export const loadUNSDGMap = () => (dispatch, getState) => {
  const myState = getState().UNSDGMap;
  const isLoading = myState.loading === true;
  const isLoaded = myState.loaded === true;
  if (isLoaded || isLoading) {
    return;
  }
  dispatch({
    type: actionTypes.LOADING_UN_SDG_MAP
  });

  return apiClient.get('o/un/sdg')
    .then(response => dispatch({
      type: actionTypes.LOADED_UN_SDG_MAP,
      data: response.data.data
    }))
    .catch(handleError(dispatch, actionTypes.ERROR_UN_SDG_MAP));
}


export const loadIndustrySectors = () => (dispatch, getState) => {
  const myState = getState().industrySectors;
  const isLoading = myState.loading === true;
  const isLoaded = myState.loaded === true;
  if (isLoaded || isLoading) {
    return;
  }
  dispatch({
    type: actionTypes.LOADING_INDUSTRY_SECTORS
  });

  return apiClient.get('o/common/industry-sectors')
    .then(response => dispatch({
      type: actionTypes.LOADED_INDUSTRY_SECTORS,
      data: response.data.data
    }))
    .catch(handleError(dispatch, actionTypes.ERROR_INDUSTRY_SECTORS));
}
